module.exports = __webpack_public_path__ + "static/img/dtitle2.9a26d92.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/dtitle2.png
// module id = 99jI
// module chunks = 0